export const DATA_SOURCE = Object.freeze({
  provider: 'providerDataSource',
  asset: 'assetDataSource'
});

export const PROVIDER_CLIENT_TYPE = Object.freeze({
  device: 'deviceProviderClient',
  edge: 'edgeProviderClient',
  cloud: 'cloudProviderClient'
});

export const PROVIDER_TYPE = Object.freeze({
  iothub: 'iothub',
  import: 'import'
});
